import { render } from "./VehicleCompartmentsTable.html?vue&type=template&id=573d1e53&scoped=true"
import script from "./VehicleCompartmentsTable.js?vue&type=script&lang=js"
export * from "./VehicleCompartmentsTable.js?vue&type=script&lang=js"

import "./VehicleCompartmentsTable.css?vue&type=style&index=0&id=573d1e53&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573d1e53"]])

export default __exports__